import { render } from "./ui-message-success.vue?vue&type=template&id=0bb82362&scoped=true&ts=true"
import script from "./ui-message-success.vue?vue&type=script&lang=ts"
export * from "./ui-message-success.vue?vue&type=script&lang=ts"

import "./ui-message-success.vue?vue&type=style&index=0&id=0bb82362&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb82362"]])

export default __exports__